import { modelRegistry } from './lib/modelConfig.js'
import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router.js'
import './styles.css'

void modelRegistry.start()
createApp(App).use(router).mount('#app')
